import React, { useEffect } from "react";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { submitGlobalContentData } from "store/actions/globalContentAction";
import { fetchGlobalContentData } from "store/actions/globalContentAction";
import Loader from "components/Loader";
import { toast } from "react-toastify";

const EmailVerify = () => {
  const dispatch = useDispatch();
  const { isLoading, emailVerify, isFetchFunctionLoading } = useSelector(
    (state) => state.globalContent
  );

  useEffect(() => {
    dispatch(fetchGlobalContentData("emailVerify"));
  }, [dispatch]);

  const initialValues = {
    verifyTitle: emailVerify?.verifyTitle || "",
    verifyText: emailVerify?.verifyText || "",
    acceptedDomainsTextlink: emailVerify?.acceptedDomainsTextlink || "",
    acceptedDomainsLink: emailVerify?.acceptedDomainsLink || "",
    sendCodeButtonText: emailVerify?.sendCodeButtonText || "",
    verifyWithIDText: emailVerify?.verifyWithIDText || "",
    acceptedFormsOfIDTextlink: emailVerify?.acceptedFormsOfIDTextlink || "",
    acceptedFormsOfIDLink: emailVerify?.acceptedFormsOfIDLink || "",
    verifyWithIDButtonText: emailVerify?.verifyWithIDButtonText || "",
    emailDoesNotMatchText: emailVerify?.emailDoesNotMatchText || "",
  };

  const validationSchema = Yup.object({
    verifyTitle: Yup.string().required("Required"),
    verifyText: Yup.string().required("Required"),
    acceptedDomainsTextlink: Yup.string().required("Required"),
    acceptedDomainsLink: Yup.string().required("Required"),
    sendCodeButtonText: Yup.string().required("Required"),
    verifyWithIDText: Yup.string().required("Required"),
    acceptedFormsOfIDTextlink: Yup.string().required("Required"),
    acceptedFormsOfIDLink: Yup.string().required("Required"),
    verifyWithIDButtonText: Yup.string().required("Required"),
    emailDoesNotMatchText: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    dispatch(
      submitGlobalContentData({ pageName: "emailVerify", ...values }, () => {
        toast.success("Data Submitted Successfully");
      })
    );
  };

  return (
    <div>
      {isFetchFunctionLoading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form className="p-4">
            <Row className="mt-3">
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Verify Title</h4>
                  </Label>
                  <Field type="text" name="verifyTitle" as={Input} />
                  <ErrorMessage
                    name="verifyTitle"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Verify Text</h4>
                  </Label>
                  <Field type="textarea" name="verifyText" as={Input} />
                  <ErrorMessage
                    name="verifyText"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Accepted Domains Textlink</h4>
                  </Label>
                  <Field
                    type="text"
                    name="acceptedDomainsTextlink"
                    as={Input}
                  />
                  <ErrorMessage
                    name="acceptedDomainsTextlink"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Accepted Domains Link (URL)</h4>
                  </Label>
                  <Field type="url" name="acceptedDomainsLink" as={Input} />
                  <ErrorMessage
                    name="acceptedDomainsLink"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Send Code Button Text</h4>
                  </Label>
                  <Field type="text" name="sendCodeButtonText" as={Input} />
                  <ErrorMessage
                    name="sendCodeButtonText"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Verify with ID Text</h4>
                  </Label>
                  <Field type="textarea" name="verifyWithIDText" as={Input} />
                  <ErrorMessage
                    name="verifyWithIDText"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Accepted Forms of ID Textlink</h4>
                  </Label>
                  <Field
                    type="text"
                    name="acceptedFormsOfIDTextlink"
                    as={Input}
                  />
                  <ErrorMessage
                    name="acceptedFormsOfIDTextlink"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Accepted Forms of ID Link (URL)</h4>
                  </Label>
                  <Field type="text" name="acceptedFormsOfIDLink" as={Input} />
                  <ErrorMessage
                    name="acceptedFormsOfIDLink"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Verify with ID Button Text</h4>
                  </Label>
                  <Field type="text" name="verifyWithIDButtonText" as={Input} />
                  <ErrorMessage
                    name="verifyWithIDButtonText"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
              <Col lg="6" xl="4">
                <FormGroup>
                  <Label>
                    <h4>Error - Email doesn't Match Accepted Domain Text</h4>
                  </Label>
                  <Field
                    type="textarea"
                    name="emailDoesNotMatchText"
                    as={Input}
                  />
                  <ErrorMessage
                    name="emailDoesNotMatchText"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mb-4">
              <Button
                type="submit"
                disabled={isLoading}
                className="btn btn-success"
              >
                {isLoading ? "Submitting" : "Submit"}
              </Button>
            </div>
          </Form>
        </Formik>
      )}
    </div>
  );
};

export default EmailVerify;
